export type PricingModel = 'royalty' | 'subscription';

export const DEFAULT_PLATFORM_SUBSCRIPTION_NET = 49.99;
export const DEFAULT_PLATFORM_SUBSCRIPTION_TAX_RATE = 21;

export interface PlatformSubscriptionAmounts {
    net: number;
    tax: number;
    gross: number;
    taxRate: number;
}

export const roundCurrency = (value: number): number =>
    Math.round((value + Number.EPSILON) * 100) / 100;

export const calculatePlatformSubscription = (
    netAmount: number = DEFAULT_PLATFORM_SUBSCRIPTION_NET,
    taxRate: number = DEFAULT_PLATFORM_SUBSCRIPTION_TAX_RATE
): PlatformSubscriptionAmounts => {
    const net = roundCurrency(netAmount);
    const tax = roundCurrency(net * (taxRate / 100));

    return {
        net,
        tax,
        gross: roundCurrency(net + tax),
        taxRate
    };
};
